import { makeStyles } from "@material-ui/core/styles";
import { RemittanceStatusEnum } from "@saleor/types/globalTypes";
import classNames from "classnames";
import React from "react";

const useStyles = makeStyles(
  () => ({
    remittanceAgingLabel: {
      overflow: "hidden",
      paddingLeft: "11px",
      paddingRight: "11px",
      textOverflow: "ellipsis"
    },

    statusDefaultLabel: {
      backgroundColor: "#C6DDFF"
    },
    statusRemittedLabel: {
      backgroundColor: "#C6DDFF"
    },
    statusToRemitLabel: {
      backgroundColor: "#EC5D77",
      color: "white"
    },

    statusWrapper: {
      borderRadius: "25px",
      display: "inline",
      margin: "2px",
      paddingBottom: "5px",
      paddingTop: "5px",
      position: "relative",
      whiteSpace: "nowrap"
    }
  }),
  { name: "RemittanceRunnerAgingBadge" }
);

export interface RemittanceRunnerStatusBadgeProps {
  aging: number;
  status: RemittanceStatusEnum;
  labelOnly?: boolean;
}

const RemittanceRunnerAgingBadge: React.FC<RemittanceRunnerStatusBadgeProps> = props => {
  const { aging, status, labelOnly = false } = props;
  const classes = useStyles(props);

  function agingToString(totalSeconds) {
    const totalMinutes = Math.floor(totalSeconds / 60);

    const seconds = totalSeconds % 60;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return hours + ":" + minutes + ":" + seconds;
  }

  const checkStatus = () => {
    switch (status) {
      case RemittanceStatusEnum.TO_REMIT:
        return (
          <div
            className={
              labelOnly
                ? undefined
                : classNames(classes.statusToRemitLabel, classes.statusWrapper)
            }
          >
            <span className={`${classes.statusToRemitLabel}`}></span>
            <span
              className={labelOnly ? undefined : classes.remittanceAgingLabel}
            >
              {agingToString(aging)}
            </span>
          </div>
        );
      case RemittanceStatusEnum.REMITTED:
        return (
          <div
            className={
              labelOnly
                ? undefined
                : classNames(classes.statusRemittedLabel, classes.statusWrapper)
            }
          >
            <span className={`${classes.statusRemittedLabel}`}></span>
            <span
              className={labelOnly ? undefined : classes.remittanceAgingLabel}
            >
              {agingToString(aging)}
            </span>
          </div>
        );
      default:
        return (
          <div
            className={
              labelOnly
                ? undefined
                : classNames(classes.statusDefaultLabel, classes.statusWrapper)
            }
          >
            <span className={`${classes.statusDefaultLabel}`}></span>
            <span
              className={labelOnly ? undefined : classes.remittanceAgingLabel}
            >
              {agingToString(aging)}
            </span>
          </div>
        );
    }
  };

  return checkStatus();
};

export default RemittanceRunnerAgingBadge;
